import { render, staticRenderFns } from "./IndividualFooter.vue?vue&type=template&id=27f72024&"
import script from "./IndividualFooter.vue?vue&type=script&lang=js&"
export * from "./IndividualFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports